module.exports = __webpack_public_path__ + "img/sport-39-@1x.996bc53b.png";